import { render } from "./verraEq7.vue?vue&type=template&id=4f87e166"
import script from "./verraEq7.vue?vue&type=script&lang=js"
export * from "./verraEq7.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__